import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    title: "电影",
    english: "MOVIES",
    icon: "ri-film-line",
    desc: "动作、科幻、悬疑、爱情，覆盖院线热门与经典佳作",
    count: "12,800+ 部",
    genres: ["动作", "科幻", "悬疑", "爱情"],
  },
  {
    type: "tv",
    title: "电视剧",
    english: "SERIES",
    icon: "ri-tv-2-line",
    desc: "国产剧、欧美剧、日韩剧，全集信息一次看清",
    count: "6,400+ 部",
    genres: ["剧情", "古装", "都市", "刑侦"],
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category?type=${entry.type}`}
          className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-300/80 p-6 md:p-7 hover:border-primary-500/70 transition-colors"
        >
          <div className="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors" />
          <div className="flex items-start gap-4 relative">
            <span className="w-14 h-14 shrink-0 rounded-lg bg-primary-500 flex items-center justify-center text-white text-2xl">
              <i className={entry.icon} />
            </span>
            <div className="flex-1">
              <div className="flex items-baseline gap-2">
                <h3 className="text-lg font-bold text-foreground-950">{entry.title}</h3>
                <span className="text-[11px] tracking-[0.25em] text-foreground-500">
                  {entry.english}
                </span>
              </div>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{entry.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {entry.genres.map((genre) => (
                  <span
                    key={genre}
                    className="px-2.5 py-1 rounded-sm bg-secondary-100 text-secondary-900 text-[11px]"
                  >
                    {genre}
                  </span>
                ))}
              </div>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{entry.count}</span>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 group-hover:gap-2 transition-all">
                  进入分类
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}